// @flow
import * as React from 'react';
import {ImArrowRight2} from "react-icons/im";
import LogoPic from "../Assets/Images/logo.png";

export default function Header(props) {
    let BG = props.transparent ?'bg-transparent' : 'bg-white';
    return (
        <React.Fragment>
            <header className={ "navbar px-2 navbar-dark bd-navbar actionbar rtl fixed-top max-w-lg text-center " + BG}>

                <div className="w-100 float-right text-small-1">

                    <img src={LogoPic} alt="NGKH" className=" " width="24"/>

                </div>

                {
                    props.hasBack &&
                    <div className="position-absolute" onClick={() => {props.backAddress ? window.location.replace(props.backAddress) :  window.history.back()} }>
                        <ImArrowRight2 />
                    </div>
                }

            </header>
        </React.Fragment>
    );
};